export const REQUEST_ENTITY_PROFILE_FETCH_AD =
  "REQUEST_ENTITY_PROFILE_FETCH_AD";
export const FETCH_ENTITY_PROFILE_AD_SUCCESS =
  "FETCH_ENTITY_PROFILE_AD_SUCCESS";
export const FETCH_ENTITY_PROFILE_AD_FAILURE =
  "FETCH_ENTITY_PROFILE_AD_FAILURE";

export const CLEAR_FETCH_ENTITY_PROFILE_AD_STATES =
  "CLEAR_FETCH_ENTITY_PROFILE_AD_STATES";
